import { get,post,upload } from '@/utils/request'

const SERVICE_URL = '/general-service/v1'
const SUPPLIER_URL = '/supplier-service/v1'

export function downLoad(params) {return post(SUPPLIER_URL + '/export/downLoad', params)}

export function listEmailTemplate(params) {return post(SUPPLIER_URL + '/emailTemplate/list', params)}
export function uploadEmailTemplate(params) {return upload(SUPPLIER_URL + '/emailTemplate/upload', params)}
export function batchDeleteEmailTmpl(params) {return post(SUPPLIER_URL + '/emailTemplate/batchDeleteEmailTmpl', params)}

export function listOfficeTemplate(params) {return post(SUPPLIER_URL + '/officeTemplate/list', params)}
export function uploadOfficeTemplate(params) {return upload(SUPPLIER_URL + '/officeTemplate/upload', params)}
export function batchDeletePoiTmpl(params) {return post(SUPPLIER_URL + '/officeTemplate/batchDeleteOfficeTmpl', params)}

// export function getUserToken(params) {return post('/framework-auth/api/v1/oauth/token', params)}
export function getUserToken(params) {return post(SERVICE_URL + '/user/login', params)}
export function quitLog(params,pathParam) {return get(SERVICE_URL + '/user/quitLog', params,pathParam)}
export function resetPW(params) {return post(SERVICE_URL + '/user/resetPW', params)}
export function setDefaultMainBody(params) {return post(SERVICE_URL + '/user/setDefaultMainBody', params)}
export function getUserInfoByToken(params) {return get(SERVICE_URL + '/user/getUserInfoByToken', params)}

/** 租户管理 */
export function fetchTenantList(params) {return post(SERVICE_URL + '/tenant/list', params)}
export function batchDeleteTenants(params) {return post(SERVICE_URL + '/tenant/deleteBatch', params)}
export function fetchMenusByTenantId(params, pathParam) {return get(SERVICE_URL + '/permission/getMenuListByTenantId', params, pathParam)}
export function fetchMenuTree(params) {return get(SERVICE_URL + '/permission/getMenuTree', params)}
export function updateTenantPerms(params){return post(SERVICE_URL + '/permission/updateTenantPermission', params)}
export function getTenantById(params, pathParam) {return get(SERVICE_URL + '/tenant/getById', params, pathParam)}
export function createTenant(params) {return post(SERVICE_URL + '/tenant/add', params)}
export function editTenant(params) {return post(SERVICE_URL + '/tenant/edit', params)}

/** 用户管理 */
export function fetchOrgForMainBody(params, pathParam) {return get(SERVICE_URL + '/org/listMainBodyOrg', params, pathParam)}
export function fetchOrgForTenant(params) {return post(SERVICE_URL + '/org/list', params)}
export function assignOrgForUser(params) {return post(SERVICE_URL + '/user/distributeOrg', params)}
export function fetchPositionForUser(params, pathParam) {return get(SERVICE_URL + '/user/getPositionByMainBodyId', params, pathParam)}
export function assignPositionForUser(params) {return post(SERVICE_URL + '/user/distributePosition', params)}
export function fetchRolesForUser(params, pathParam) {return get(SERVICE_URL + '/user/getRoleByMainBodyId', params, pathParam)}
export function assignRolesForUser(params) {return post(SERVICE_URL + '/user/distributeRole',params)}
export function getUserById(params) {return post(SERVICE_URL + '/user/getUserInfo', params)}
export function fetchMainBodyByUserId(params, pathParam) {return get(SERVICE_URL + '/mainbody/getByUserId',params, pathParam)}
export function fetchUserList(params) {return post(SERVICE_URL + '/user/getUserList', params)}

export function getUser(params) {return post(SERVICE_URL + '/user/getUser', params)}
export function updatePassword(params) {return post(SERVICE_URL + '/user/updatePassword', params)}
export function updateMyPassword(params) {return post(SERVICE_URL + '/user/updateMyPassword', params)}
export function deleteUser(params) {return post(SERVICE_URL + '/user/deleteUser', params)}
export function createUser(params) {return post(SERVICE_URL + '/user/addUser', params)}
export function editUser(params) {return post(SERVICE_URL + '/user/updateUser', params)}
export function fetchMainBodyForTenant(params) {return post(SERVICE_URL + '/mainbody/list', params)}
export function getMainBodyById(params, pathParam) {return get(SERVICE_URL + '/mainbody/getById', params, pathParam)}
export function getRoleForUser(params) {return post(SERVICE_URL + '/user/getRole', params)}
export function getRealNameById(params) {return get(SERVICE_URL + '/user/getRealNameById', params)}

/** 角色管理 */
export function fetchRolesList(params) {return post(SERVICE_URL + '/role/getRolePageList', params)}
export function deleteRole(params) {return post(SERVICE_URL + '/role/deleteRole',params)}
export function fetchBgTreeForMainBody(params, pathParam) {return get(SERVICE_URL + '/permission/getMenuTreeByMainBodyId', params, pathParam)}
export function fetchPermsByRoleId(params, pathParam) {return get(SERVICE_URL + '/role/getPermissionByRoleId', params, pathParam)}
export function assignPermsForRole(params) {return post(SERVICE_URL + '/role/relevancePermission', params)}
export function getRoleById(params, pathParam) {return get(SERVICE_URL + '/role/getRoleById', params, pathParam)}
export function createRole(params) {return post(SERVICE_URL + '/role/addRole', params)}
export function editRole(params) {return post(SERVICE_URL + '/role/updateRoleById`', params)}

/** 岗位编制管理 */
export function fetchPositionList(params) {return post(SERVICE_URL + '/position/list', params)}
export function getSysPositionList() {return get(SERVICE_URL + '/position/getSysPositionList')}
export function deletePosition(params, pathParam) {return get(SERVICE_URL + '/position/delete', params, pathParam)}
export function assignOrgForPosition(params) {return post(SERVICE_URL + '/position/relatedOrg', params)}
export function createPosition(params) {return post(SERVICE_URL + '/position/add', params)}
export function editPosition(params) {return post(SERVICE_URL + '/position/edit', params)}
export function getPositionById(params, pathParam) {return get(SERVICE_URL + '/position/getById', params, pathParam)}
export function assignDataAuthority(params) {return post(SERVICE_URL + '/position/assignDataAuthority', params)}
export function getPurchaseLeaderList() {return get(SERVICE_URL + '/position/getPurchaseLeaderList')}
export function getCurrentUserPosition() {return get(SERVICE_URL + '/position/getCurrentUserPosition')}

/** 组织管理 */
export function deleteOrg(params, pathParam) {return get(SERVICE_URL + '/org/delete', params, pathParam)}
export function getOrgById(params, pathParam) {return get(SERVICE_URL + '/org/getById', params, pathParam)}
export function createOrg(params) {return post(SERVICE_URL + '/org/add', params)}
export function editOrg(params) {return post(SERVICE_URL + '/org/edit', params)}
export function getParentOrgType(params) {return post(SERVICE_URL + '/org/getParentOrgType', params)}


/** 菜单操作配置 */
export function deleteMenuAction(params, pathParam) {return get(SERVICE_URL + '/permission/deleteMenuInfoById', params, pathParam)}
export function getMenuActionById(params, pathParam) {return get(SERVICE_URL + '/permission/getMenuInfoById', params, pathParam)}
export function createMenuAction(params) {return post(SERVICE_URL + '/permission/addSubMainMenu', params)}
export function editMenuAction(params) {return post(SERVICE_URL + '/permission/updateMenuInfoById', params)}
// 根据用户id和访问地址判断用户是否有访问地址的权限
export function isHasRouterUrlPermission(params) {return get(SUPPLIER_URL + '/permission/isHasRouterUrlPermission', params)}
// 根据用户id和按钮表达式判断用户是否有访问按钮的权限
export function isHasButtonPermission(params) {return get(SUPPLIER_URL + '/permission/isHasButtonPermission', params)}

/** 主体管理 */
export function batchDeleteMainBody(params) {return post(SERVICE_URL + '/mainbody/deleteBatch', params)}
export function createMainBody(params) {return post(SERVICE_URL + '/mainbody/add', params)}
export function editMainBody(params) {return post(SERVICE_URL + '/mainbody/edit', params)}
export function fetchBgTreeForTenant(params, pathParam) {return get(SERVICE_URL + '/permission/getMenuTreeByTenantId', params, pathParam)}
export function fetchMenusByMainBodyId(params, pathParam) {return get(SERVICE_URL + '/permission/getMenuListByMainBodyId', params, pathParam)}
export function updateMainBodyPerms(params){return post(SERVICE_URL + '/permission/updateMainBodyPermission', params)}
export function fetchRootOrg(params) {return post(SERVICE_URL + '/org/listRoot', params)}
export function assignOrgForMainBody(params) {return post(SERVICE_URL + '/mainbody/relatedOrg', params)}

/** 系统参数管理 */
export function fetchConstantList(params) {return post(SERVICE_URL + '/constant/list', params)}
export function batchDeleteConstant(params) {return post(SERVICE_URL + '/constant/deleteBatch', params)}
export function getConstantById(params, pathParam) {return get(SERVICE_URL + '/constant/getById', params, pathParam)}
export function createConstant(params) {return post(SERVICE_URL + '/constant/add', params)}
export function editConstant(params) {return post(SERVICE_URL + '/constant/edit', params)}

/** 系统编码管理 */
export function fetchCodeTypeList(params) {return post(SERVICE_URL + '/codetype/list', params)}
export function batchDeleteCodeType(params) {return post(SERVICE_URL + '/codetype/deleteBatch', params)}
export function getCodeTypeById(params, pathParam) {return get(SERVICE_URL + '/codetype/getById', params, pathParam)}
export function createCodeType(params) {return post(SERVICE_URL + '/codetype/add', params)}
export function editCodeType(params) {return post(SERVICE_URL + '/codetype/edit', params)}
export function listItems(params) {return get(SERVICE_URL + '/codetype/listItems', params)}
export function fetchCodeItems(params, pathParam) {return get(SERVICE_URL + '/codeitem/list', params, pathParam)}
export function batchDeleteCodeItem(params) {return post(SERVICE_URL + '/codeitem/deleteBatch', params)}
export function getCodeItemById(params, pathParam) {return get(SERVICE_URL + '/codeitem/getById', params, pathParam)}
export function createCodeItem(params) {return post(SERVICE_URL + '/codeitem/add', params)}
export function editCodeItem(params) {return post(SERVICE_URL + '/codeitem/edit', params)}
/** 订单管理 */
export function fetchOrderList(params) {return post(SERVICE_URL + '/service/order/list', params)}
export function getOrderDetail(params) {return post(SERVICE_URL + '/service/order/detail', params)}
export function deleteOrder(params) {return post(SERVICE_URL + '/service/order/delete', params)}
// /** 项目管理 */
// export function fetchProjectList(params) {return post(SERVICE_URL + '/service/project/list', params)}
// export function getProjectPlan(params) {return post(SERVICE_URL + '/service/project/plan', params)}
// export function getProjectRate(params) {return post(SERVICE_URL + '/service/project/rate', params)}
// export function deleteProject(params) {return post(SERVICE_URL + '/service/project/delete', params)}
// /** 技术通知管理 */
// export function fetchTechList(params) {return post(SERVICE_URL + '/service/tech/list', params)}
// export function getAppartmentList(params) {return post(SERVICE_URL + '/service/tech/appartmentList', params)}
// export function getSupplierList(params) {return post(SERVICE_URL + '/service/tech/supplierList', params)}
// export function deleteTech(params) {return post(SERVICE_URL + '/service/tech/delete', params)}
// /** 任务通知管理 */
// export function fetchTaskList(params) {return post(SERVICE_URL + '/service/task/list', params)}
// // export function getAppartmentList(params) {return post(SERVICE_URL + '/service/tech/appartmentList', params)}
// // export function getSupplierList(params) {return post(SERVICE_URL + '/service/tech/supplierList', params)}
// export function deleteTask(params) {return post(SERVICE_URL + '/service/task/delete', params)}
/** 交货单管理 */
export function fetchDeliveryList(params) {return post(SERVICE_URL + '/service/delivery/list', params)}
export function getDeliveryDetail(params) {return post(SERVICE_URL + '/service/delivery/detail', params)}
export function deleteDelivery(params) {return post(SERVICE_URL + '/service/delivery/delete', params)}
// /** 供应商管理 */
// export function fetchSupplierList(params) {return post(SERVICE_URL + '/service/supplier/list', params)}
// export function getSupplierDetail(params) {return post(SERVICE_URL + '/service/supplier/detail', params)}
// export function deleteSupplier(params) {return post(SERVICE_URL + '/service/supplier/delete', params)}
/** 合同管理 */
export function fetchContractList(params) {return post(SERVICE_URL + '/service/contract/list', params)}
export function getContractDetail(params) {return post(SERVICE_URL + '/service/contract/detail', params)}
export function deleteContract(params) {return post(SERVICE_URL + '/service/contract/delete', params)}
// /** 询价包 */
// export function fetchRFQList(params) {return post(SERVICE_URL + '/service/rfq/list', params)}
// // export function getAppartmentList(params) {return post(SERVICE_URL + '/service/tech/appartmentList', params)}
// // export function getSupplierList(params) {return post(SERVICE_URL + '/service/tech/supplierList', params)}
// export function deleteRFQ(params) {return post(SERVICE_URL + '/service/rfq/delete', params)}
// /** 报价包 */
// export function fetchQuotationList(params) {return post(SERVICE_URL + '/service/quotation/list', params)}
// // export function getAppartmentList(params) {return post(SERVICE_URL + '/service/tech/appartmentList', params)}
// // export function getSupplierList(params) {return post(SERVICE_URL + '/service/tech/supplierList', params)}
// export function deleteQuotation(params) {return post(SERVICE_URL + '/service/quotation/delete', params)}
/** 价格协议管理 */
export function fetchPriceAgreementList(params) {return post(SERVICE_URL + '/service/priceAgreement/list', params)}
export function getPriceAgreementDetail(params) {return post(SERVICE_URL + '/service/priceAgreement/detail', params)}
export function deletePriceAgreement(params) {return post(SERVICE_URL + '/service/priceAgreement/delete', params)}


/**日志管理**/
export function getLogList(params) {return post(SERVICE_URL + '/log/getLogList', params)}

/**附件管理 */
export function getUrl(params) {return get(SERVICE_URL + '/file/getUrl', params)}
export function getFileUrl(params) {return get(SERVICE_URL + '/file/getFileUrl', params)}
export function getFileList(params) {return get(SERVICE_URL + '/file/getFileList', params)}
export function uploadFile(params) {return upload(SERVICE_URL + '/file/upload', params)}
export function uploadBase64(params) {return post(SERVICE_URL + '/file/uploadBase64', params)}
export function deleteFileById(params) {return get(SERVICE_URL + '/file/deleteFileById', params)}
export function getChangeFileList(params) {return get(SERVICE_URL + '/file/getChangeFileList', params)}
//获取子公司
export function orgList(params) {
    return post(SERVICE_URL + '/org/orgList', params)}
    //获取子公司列表
export function supCompanyList(){return get(SERVICE_URL + '/org/supCompanyList')}
export function workList(){return get(SERVICE_URL + '/org/workList')}
export function workAllList(){return get(SERVICE_URL + '/org/workAllList')}

export function getWerkBySubcode(params, pathParam){return get(SERVICE_URL + '/org/getWerkBySubcode', params, pathParam)}
export function purList(){return get(SERVICE_URL + '/org/purList')}
//箱标签查询
export function getSubcompanyBoxLabel(params) {
    return post(SERVICE_URL + '/org/getSubcompanyBoxLabel', params)}
//获取子公司列表